/* src/app/views/template/components/edit-template-menu/edit-template-product-menu/edit-template-product-menu.component.scss */
/*# sourceMappingURL=edit-template-product-menu.component.css.map */
